import { IPackageProgramItem } from 'services/shop/types/package-program';
import { formatCurrency } from 'utils/formatCurrency';
import { ProgramHeader } from './styles';

type Props = {
  program: IPackageProgramItem;
};

// Tên, mô tả và giá mỗi buổi của program đang chọn
const PackageProgramHeader = ({ program }: Props) => (
  <ProgramHeader>
    <div>
      <p className='program-name'>{program.name}</p>
      {!!program.description && <p className='program-description'>{program.description}</p>}
    </div>
    <p className='program-price'>
      {formatCurrency(program.price)}
      <span className='per-session'>/session</span>
    </p>
  </ProgramHeader>
);

export default PackageProgramHeader;
